import { useQuery } from '@tanstack/react-query';
import { referAndEarnApi } from '..';

const useGetReferredLeadsList = () => {
  const { data, isLoading, isRefetching } = useQuery({
    queryKey: ['referredLeadsList'],
    queryFn: () => referAndEarnApi.getReferredLeadsList(),
    placeholderData: { leads: [] },
  });
  return { data, isLoading: isLoading || isRefetching };
};

export default useGetReferredLeadsList;
